import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useModuleByIdQuery } from '@entities/Module';
import { ModuleHero, ModuleWords } from '@features/ModuleDetail';
import { useIsSidebarMobile } from '@widgets/Sidebar';

/**
 * Страница своего модуля — одна разметка на desktop и mobile (макет «Мой
 * модуль»). На мобайле глобальный гамбургер на этом маршруте спрятан: его
 * место занимает кнопка «назад» (см. Sidebar). Статистика (ModuleKpis)
 * временно убрана по запросу — компонент сохранён в @features/ModuleDetail.
 */
export default function ModuleDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { data: module, isLoading } = useModuleByIdQuery(id ?? null);
  const isMobile = useIsSidebarMobile();

  if (isLoading) {
    return (
      <div className="mx-auto max-w-[1400px] animate-fadeIn px-4 pt-16 sm:px-6 nav:px-12 nav:pt-12">
        <div className="h-9 w-40 animate-skeleton rounded bg-card" />
        <div className="mt-6 h-[120px] animate-skeleton rounded-card bg-card" />
        <div className="mt-7 h-[160px] animate-skeleton rounded-card bg-card" />
      </div>
    );
  }

  if (!module) {
    return (
      <div className="mx-auto max-w-[1400px] animate-fadeIn px-4 pt-16 text-center text-muted sm:px-6 nav:px-12 nav:pt-12">
        {t('moduleDetail.notFound')}
      </div>
    );
  }

  return (
    <div className="md animate-fadeIn">
      <ModuleHero module={module} />
      <ModuleWords module={module} mobile={isMobile} />
    </div>
  );
}
